"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _BubbleGroup = require("./BubbleGroup");
Object.keys(_BubbleGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _BubbleGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _BubbleGroup[key];
    }
  });
});
